import { gate } from 'hub-http/gates';
export const gates = {
  CONVERSATIONAL_ENRICHMENT_BETA: gate('ConversationalEnrichment:EmailParser:Beta'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE: gate('ConversationalEnrichment:Model:EmploymentChange'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE_TOGGLE: gate('ConversationalEnrichment:FEToggle:EmploymentChange'),
  CONVERSATIONAL_ENRICHMENT_OUT_OF_OFFICE_TOGGLE: gate('ConversationalEnrichment:FEToggle:OutOfOffice'),
  DATA_AGENT_PAGE: gate('DataAgent:Page'),
  DATA_AGENT_PERMISSIONS: gate('Permissions:DataAgent'),
  ENRICHMENT_INCLUDED: gate('DataEnrichment:Included'),
  HUBSPOT_CREDITS: gate('HubSpotCredits'),
  SMART_PROPERTIES_CONTACT: gate('SmartProperties::Contact'),
  USAGE_BASED_BILLING: gate('UsageBasedBilling:Inbound2025')
};